(() => {
  const desktop = window.matchMedia('(min-width: 1101px)');

  /* Remove the temporary sticky-header experiment so CSS can restore the original behavior. */
  const clearLegacySticky = () => {
    const header = document.querySelector('.fr-header');
    if (!header) return;
    const shell = header.closest('.shopify-section') || header.parentElement;

    if (shell && shell.dataset.frStickyHeader === 'true') {
      delete shell.dataset.frStickyHeader;
      shell.style.removeProperty('position');
      shell.style.removeProperty('top');
      shell.style.removeProperty('z-index');
    }

    header.style.removeProperty('position');
    header.style.removeProperty('top');
  };

  const normalizeMenu = () => {
    if (!desktop.matches) return;
    const drawer = document.querySelector('[data-mobile-menu]');
    const trigger = document.querySelector('[data-menu-toggle]');
    if (drawer && !drawer.hidden) drawer.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };

  clearLegacySticky();

  if (desktop.addEventListener) desktop.addEventListener('change', normalizeMenu);
  window.addEventListener('pageshow', () => {
    clearLegacySticky();
    normalizeMenu();
  });
  document.addEventListener('shopify:section:load', clearLegacySticky);
})();
